import { FC } from 'react';

import { ChatLayout } from './chat-layout';
import { InputArea } from './input-area';
import { MessagesArea } from './messages-area';

import { ChatState } from '../types/chat-state';

export const Chat: FC<{
  state: ChatState;
}> = ({
  state: {
    internalState: { messages, input, isEditing, isTyping, setIsEditing, undo },
  },
}) => (
  <ChatLayout
    messages={
      <MessagesArea
        isEditing={isEditing}
        isTyping={isTyping}
        messages={messages}
      />
    }
    input={<InputArea input={input} isEditing={isEditing} />}
    isEditing={isEditing}
    setIsEditing={setIsEditing}
    undo={undo}
  />
);
